import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../../css/Manage.css";
import "../../css/generalmember/ManageGeneralMemberMessage.css";
import { toast } from "react-toastify";
import SpaceApi from "../../api/spaceApi";
import moment from "moment";
import CouponApi from "../../api/couponApi";
const ManageCouponAdd = () => {
  const navigate = useNavigate();

  const [spaceOption, setSpaceOption] = useState();
  const [openMenu, setOpenMenu] = useState(false);

  const [openTypeSelect, setOpenTypeSelect] = useState(false);
  const [type, setType] = useState();
  const [space, setSpace] = useState();

  const [name, setName] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [discountPercent, setDiscountPercent] = useState("");
  const [dueAt, setDueAt] = useState("");

  const onSubmit = async () => {
    await CouponApi.Post({
      name,
      subtitle,
      type: type?.value,
      target: "ALL",
      spaceId: space?.value,
      dueAt,
      discountPercent: Number(discountPercent),
    }).then(() => {
      toast("쿠폰이 생성되었습니다.");
      navigate(-1);
    });
  };

  useEffect(() => {
    SpaceApi.Get()
      .then((res) => {
        const options = res.data.data.content.map((v) => ({
          label: v.name,
          value: v.id,
        }));
        setSpaceOption(options);
      })
      .catch(() => toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요."));
  }, []);

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-general-member-adit">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-message-adit">
          <span>쿠폰 생성</span>
          <div className="Manage-input-container Manage-input-container-general-member-message">
            <span className="Manage-input-title">이름*</span>
            <input
              className="Manage-input-textarea manage-form-general-member-adit-input"
              type="text"
              placeholder="이름"
              required
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="Manage-input-container Manage-input-container-general-member-message">
            <span className="Manage-input-title">서브 타이틀*</span>
            <input
              className="Manage-input-textarea manage-form-general-member-adit-input"
              type="text"
              placeholder="서브 타이틀"
              required
              onChange={(e) => setSubtitle(e.target.value)}
            />
          </div>
          <div className="Manage-input-container Manage-input-container-space-adit">
            <p className="Manage-input-title">타입*</p>
            <div className="select">
              <div
                className="selected"
                onClick={() => setOpenTypeSelect((v) => !v)}
              >
                <div className="selected-value">{type?.label}</div>
                <div className="select-toggle-btn">
                  <img src="\img\table-togle.svg" />
                </div>
              </div>
              {openTypeSelect ? (
                <ul className="option-container">
                  {COUPON_TYPE_OPTIONS?.map((v) => {
                    return (
                      <li
                        key={v.value}
                        className="option"
                        onClick={() => {
                          setType({ label: v.label, value: v.value });
                          setOpenTypeSelect(false);
                        }}
                      >
                        {v.label}
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
          </div>
          {type?.value === "SPACE" && (
            <div className="Manage-input-container Manage-input-container-space-adit">
              <p className="Manage-input-title">공간*</p>
              <div className="select">
                <div
                  className="selected"
                  onClick={() => setOpenMenu((v) => !v)}
                >
                  <div className="selected-value">{space?.label}</div>
                  <div className="select-toggle-btn">
                    <img src="\img\table-togle.svg" />
                  </div>
                </div>
                {openMenu ? (
                  <ul className="option-container">
                    {spaceOption?.map((v) => {
                      return (
                        <li
                          key={v.value}
                          className="option"
                          onClick={() => {
                            setSpace({ label: v.label, value: v.value });
                            setOpenMenu(false);
                          }}
                        >
                          {v.label}
                        </li>
                      );
                    })}
                  </ul>
                ) : null}
              </div>
            </div>
          )}

          <div className="Manage-input-container Manage-input-container-general-member-message">
            <span className="Manage-input-title">할인</span>
            <input
              className="Manage-input-textarea manage-form-general-member-adit-input"
              type="text"
              placeholder="할인"
              required
              onChange={(e) => setDiscountPercent(e.target.value)}
            />
          </div>
          <div className="Manage-input-container Manage-input-container-postdate">
            <p className="Manage-input-title">만료일자*</p>
            <div className="Manage-date-postdate Manage-date-postdate-gathering">
              <input
                type="datetime-local"
                required
                data-placeholder="NNNN-NN-NN --:--"
                value={dueAt}
                onChange={(e) =>
                  setDueAt(
                    moment(new Date(e.target.value)).format(
                      "yyyy-MM-DD HH:mm:ss"
                    )
                  )
                }
              />
            </div>
          </div>

          <div className="Manage-form-save manage-form-save-general-member-adit">
            <button className="cursorPointer" onClick={onSubmit}>
              생성하기
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageCouponAdd;

const COUPON_TYPE_OPTIONS = [
  { label: "모임", value: "MEETING" },
  { label: "거주권", value: "RESIDENCY" },
  { label: "공간", value: "SPACE" },
];
